import { useEffect, useMemo } from 'react';
import { Assessment, AssessmentSurvey } from '../interfaces/assessment.interface';
import { Survey } from '../interfaces/survey.interface';
import { useNavigate } from 'react-router-dom';

function getSurveyId(ref: number | AssessmentSurvey): number | null {
  if (typeof ref === 'number') return ref;

  const s = ref.survey;
  if (typeof s === 'number') return s;
  if (typeof s === 'object'
        && s !== null
        && 'id' in s
        && typeof s.id === 'number'
  ) {
    return s.id;
  }

  return null;
}

export function useValidAssessmentSurveyRelationship(
  assessment?: Assessment,
  survey?: Survey,
) {
  const navigate = useNavigate();

  const isValid = useMemo(() => {
    if (!assessment || !survey) return true;

    return assessment.surveys.some((s) => getSurveyId(s) === survey.id);
  }, [assessment, survey]);

  useEffect(() => {
    if (!isValid) navigate('/', { replace: true });
  }, [isValid, navigate]);

  return isValid;
}
